import { FC } from "react";
import { Link } from "react-router-dom";
import { imgLogoShort } from "@/shared/assets/img";
import { PlayIcon } from "@/shared/icons";
import AuthTitle from "@/domains/auth/components/AuthTitle.tsx";

interface AuthSignUpSuccessProps {
  socialClub: string;
}

const AuthSignUpSuccess: FC<AuthSignUpSuccessProps> = function AuthSignUpSuccess({ socialClub }) {
  return (
    <>
      <AuthTitle>Успешная регистрация</AuthTitle>
      <div className="relative grow rounded-lg p-6 flex flex-col justify-center items-center text-center">
        <div className="rounded-border" />
        <img src={imgLogoShort} className="w-12 aspect-square mb-5" alt="" />
        <div className="text-18 mb-3 font-bold">
          Добро пожаловать на Region RolePlay
          <div className="font-bold text-accent truncate max-w-[20rem] mx-auto">{socialClub}</div>
        </div>
        <div className="text-15">
          Желаем приятной игры и море удовольствия от игровых систем, которые мы для вас
          приготовили!
        </div>
      </div>
      <Link
        to="/account"
        className="btn btn--md variant-solid-gradient w-full mt-7.5 uppercase text-13 gap-2.5"
      >
        <PlayIcon size={22} />
        Начать игру
      </Link>
    </>
  );
};

export default AuthSignUpSuccess;
